<template>
  <div class="modal-holder">
    <Transition name="bounce">
      <div class="modal-content" v-if="showModalContent">
        <div class="modal-row">
          <div class="heading">
            <h5>Payment Methods List <span></span></h5>
            <i class="bi bi-x-circle" @click="$emit('closeModal')"></i>
          </div>
        </div>
        <DefaultLoader v-if="isLoading"></DefaultLoader>
        <div v-else class="modal-row table-responsive">
          <button
            class="btn btn-xs btn-primary"
            style="float: right; margin-bottom: 10px"
            @click="
              selectedPaymentMethod = null;
              showPaymentMethodFormModal = true;
            "
          >
            Add New Payment Method
          </button>
          <table class="table partner-table">
            <thead>
              <tr>
                <th>SL</th>
                <th>Pay. Method</th>
                <th>Bank</th>
                <th>Account No</th>
                <th>Customer Name</th>
                <th>Routing No</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="paymentMethodList?.length">
                <tr
                  v-for="(paymentMethod, index) in paymentMethodList"
                  :key="paymentMethod.id"
                >
                  <td>{{ index + 1 }}</td>
                  <td>
                    {{
                      paymentMethod.payment_method
                        ? paymentMethod.payment_method
                        : 'N/A'
                    }}
                  </td>
                  <td>
                    {{
                      paymentMethod.bank_name ? paymentMethod.bank_name : 'N/A'
                    }}
                  </td>
                  <td>
                    {{
                      paymentMethod.account_no
                        ? paymentMethod.account_no
                        : 'N/A'
                    }}
                  </td>
                  <td>
                    {{
                      paymentMethod.customer_name
                        ? paymentMethod.customer_name
                        : 'N/A'
                    }}
                  </td>
                  <td>
                    {{
                      paymentMethod.routing_no
                        ? paymentMethod.routing_no
                        : 'N/A'
                    }}
                  </td>
                  <td>
                    <span class="text-info" v-if="paymentMethod.default"
                      >Default</span
                    >
                    <span v-else>Alternative</span>
                  </td>
                  <td>
                    <button
                      class="btn btn-xs btn-info"
                      style="margin-right: 5px"
                      v-if="!paymentMethod.default"
                      @click="setDefaultPaymentMethod(paymentMethod)"
                    >
                      Make Default
                    </button>
                    <button
                      class="btn btn-xs btn-primary"
                      style="margin-right: 5px"
                      @click="
                        selectedPaymentMethod = paymentMethod;
                        showPaymentMethodFormModal = true;
                      "
                    >
                      <i class="bi bi-pencil-square"></i>
                    </button>
                    <button
                      v-if="!paymentMethod.default"
                      class="btn btn-xs btn-danger"
                      @click="deletePaymentMethod(paymentMethod)"
                    >
                      <i class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              </template>
              <tr v-else>
                <td colspan="50" class="text-center text-danger">
                  No payment methods found!
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Transition>
  </div>
  <!-- Payment Method Form Modal -->
  <Transition name="fade">
    <PaymentMethodForm
      v-if="showPaymentMethodFormModal"
      :userCode="userCode"
      :date="date"
      :tzoffset="tzoffset"
      :modality="modality"
      :serviceType="serviceType"
      :paymentMethod="selectedPaymentMethod"
      @refreshData="
        getPaymentMethodList();
        $emit('refreshData');
      "
      @closeModal="showPaymentMethodFormModal = !showPaymentMethodFormModal"
    ></PaymentMethodForm>
  </Transition>
</template>
  
<script>
import PaymentMethodForm from './PaymentMethodForm.vue';
import http from '../../config/axios';
export default {
  props: ['userCode', 'date', 'modality', 'serviceType'],
  components: {
    PaymentMethodForm
  },
  data() {
    return {
      showModalContent: false,
      showPaymentMethodFormModal: false,
      isLoading: false,
      paymentMethodList: [],
      selectedPaymentMethod: null,
      tzoffset: new Date().getTimezoneOffset() * 60000
    };
  },
  mounted() {
    this.showModalContent = true;
    this.getPaymentMethodList();
  },
  //   watch: {
  //     userCode() {
  //       this.getPaymentMethodList();
  //     }
  //   },
  methods: {
    getPaymentMethodList() {
      this.isLoading = true;

      http
        .get(
          `/v2/partners/bills/payment/method/list?user_code=${this.userCode}`
        )
        .then((response) => {
          this.isLoading = false;
          this.paymentMethodList = response.data.data;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$partnerSwal.errorToast.fire({
            title: 'Error!',
            text: error?.response?.data?.message
          });
        });
    },
    setDefaultPaymentMethod(paymentMethod) {
      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10);

      this.$partnerSwal.confirmationAlert
        .fire({
          title: 'Are you sure?',
          text: 'This will be default payment method & all other methods will be alternative!',
          confirmButtonText: 'Make Default!'
        })
        .then((result) => {
          if (result.isConfirmed) {
            http
              .patch(
                `/v2/partners/bills/update/payment/method/${paymentMethod.id}`,
                {
                  billing_trip_start_date: startDate,
                  billing_trip_end_date: endDate,
                  modality: this.modality,
                  service_type: this.serviceType,
                  user_code: paymentMethod.user_code,
                  payment_method: paymentMethod.payment_method,
                  account_no: paymentMethod.account_no,
                  bank_name: paymentMethod.bank_name,
                  customer_name: paymentMethod.customer_name,
                  routing_no: paymentMethod.routing_no,
                  default: 1
                }
              )
              .then((response) => {
                this.getPaymentMethodList();
                this.$emit('refreshData');
                this.$partnerSwal.quickSuccessAlert.fire({
                  title: 'Success',
                  text: response.data?.message
                });
              })
              .catch((error) => {
                this.isLoading = false;
                this.$partnerSwal.errorToast.fire({
                  title: 'Error!',
                  text: error.response?.data?.message
                });
              });
          }
        });
    },
    deletePaymentMethod(paymentMethod) {
      this.$partnerSwal.confirmationAlert
        .fire({
          title: 'Are you sure?',
          text: 'This payment method will be deleted permanently!',
          confirmButtonText: 'Delete!'
        })
        .then((result) => {
          if (result.isConfirmed) {
            http
              .delete(
                `/v2/partners/bills/delete/payment/method/${paymentMethod.id}`
              )
              .then((response) => {
                this.getPaymentMethodList();
                this.$emit('refreshData');
                this.$partnerSwal.quickSuccessAlert.fire({
                  title: 'Success',
                  text: response.data?.message
                });
              })
              .catch((error) => {
                this.isLoading = false;
                this.$partnerSwal.errorToast.fire({
                  title: 'Error!',
                  text: error.response?.data?.message
                });
              });
          }
        });
    }
  }
};
</script>
  
<style scoped>
.modal-holder {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(18, 18, 18, 0.6);
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
}
.modal-content {
  background: #fff;
  width: 850px;
  padding: 0 20px;
  border-radius: 12px;
  max-height: 100%;
  overflow: auto;
}
.modal-row {
  padding: 16px 0;
  border-bottom: 0.5px solid #d5d5d5;
}
.modal-row:last-child {
  border-bottom: none;
}
h5,
h6,
ul {
  margin-bottom: 0;
}
.modal-row ul {
  padding-left: 0;
}
.modal-row ul li {
  list-style: none;
}

.heading h5 {
  font-size: 20px;
  font-weight: 500;
  float: left;
  line-height: 24.38px;
}
.heading h5 span {
  color: #a95eea;
}
.heading i {
  cursor: pointer;
  float: right;
  font-size: 20px;
  color: #949494;
  line-height: 24.38px;
}
.heading i:hover {
  color: red;
}
.bounce-enter-active {
  animation: bounce-in 0.4s;
}
.bounce-leave-active {
  animation: bounce-in 0.4s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>
  